import { useCallback, useEffect, useState } from "react";
import { useConversationsApi } from "../api/conversationsApi";

// Recebe valores primitivos (e não um objeto de intervalo) para o efeito não
// disparar a cada render por identidade nova.
export function useAnalysisOverview(days = 30, from = null, to = null) {
  const api = useConversationsApi();
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOverview = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAnalysesOverview({ days, from, to });
      setOverview(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api, days, from, to]);

  useEffect(() => {
    fetchOverview();
  }, [fetchOverview]);

  return { overview, loading, error, refetch: fetchOverview };
}
